import { getters } from "@/constants/state";

export default {
  [getters.USERS_ENABLED_GETTER]: (state) => state.enabledUsers,
};
